import { render, staticRenderFns } from "./IconMinusCircle.vue?vue&type=template&id=7cca8532"
import script from "./IconMinusCircle.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconMinusCircle.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports